import { useQuery } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Label } from 'types';

const getLabels = async (orgId: string, projectId?: string): Promise<Label[]> => {
  const params = new URLSearchParams({ orgId });
  if (projectId) {
    params.append('projectId', projectId);
  }
  const response = await customAxios.get<Label[]>(`/labels?${params.toString()}`);
  return response.data;
};

export const useGetLabels = (orgId: string, projectId?: string) =>
  useQuery<Label[]>({
    queryKey: ['labels', orgId, projectId],
    queryFn: () => getLabels(orgId, projectId),
    enabled: !!orgId,
  });
